import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import seoConfig from "./seoConfig";

const SEO = () => {
  const { pathname } = useLocation();
  console.log(pathname, "path");
  
  const baseUrl = "https://www.itdoseinfo.com";

  const normalizePath = (urlPath) => {
    if (!urlPath) return "/";
    return (
      urlPath
        .split("?")[0]
        .split("#")[0]
        .replace(/\/{2,}/g, "/")
        .replace(/\/+$/, "")
        .toLowerCase() || "/"
    );
  };

  const cleanPath = normalizePath(pathname);

  // const cleanPath = pathname.replace(/\/+/g, "/");
  const canonicalUrl = cleanPath === "/" ? baseUrl + "/" : `${baseUrl}${cleanPath}`;

  const seo = seoConfig[cleanPath];

  useEffect(() => {
    //----Canonical URL ---

    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);



    if (!seo) return;
    document.title = seo.title;

    const setMeta = (name, content) => {
      let tag = document.querySelector(`meta[name='${name}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta("description", seo.description);
    setMeta("keywords", seo.keywords);

  }, [cleanPath, seo]);

  return null;
};

export default SEO;
